import {defineRouting} from 'next-intl/routing';

export const locales = ['en', 'es', 'de', 'nl', 'pt', 'it', 'fr'] as const;
export type Locale = (typeof locales)[number];

export const routing = defineRouting({
  locales,
  defaultLocale: 'en',
  localePrefix: 'as-needed',
  // We don't need localized pathnames for now
  // pathnames: {
  //   '/': '/',
  //   '/contact': {
  //     en: '/contact',
  //     es: '/contacto'
  //   }
  // }
}); 